/* Galeria do produto no celular — Almacén Rumbia: setas < > e janela de 5 bolinhas que acompanha a foto atual */
(function () {
  var ICON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function init(wrap) {
    var list = wrap.querySelector('media-dots');
    if (!list || wrap.querySelector('.rg-arrow')) return;

    function dots() { return Array.from(list.children).filter(function (d) { return !d.hidden; }); }
    function current() { return dots().findIndex(function (d) { return d.getAttribute('aria-current') === 'true'; }); }

    function arrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rg-arrow rg-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Foto anterior' : 'Foto siguiente');
      b.innerHTML = ICON[dir];
      b.addEventListener('click', function () {
        var all = dots(), i = current(), j = dir === 'prev' ? i - 1 : i + 1;
        if (all[j]) all[j].click();
      });
      return b;
    }

    var prev = arrow('prev'), next = arrow('next');
    wrap.insertBefore(prev, list);
    wrap.appendChild(next);

    function sync() {
      var all = dots(), i = current(), d = all[i];
      prev.disabled = i <= 0;
      next.disabled = i < 0 || i >= all.length - 1;
      if (d) list.scrollTo({ left: d.offsetLeft - (list.clientWidth - d.offsetWidth) / 2, behavior: 'smooth' });
    }

    new MutationObserver(sync).observe(list, { subtree: true, attributes: true, attributeFilter: ['aria-current', 'hidden'] });
    sync();
  }

  // Botões .rd-cta da descrição: abrem o popup do EasySell; sem o botão dele, rolam até o formulário
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('.rd-cta');
    if (!cta) return;
    e.preventDefault();
    var form = document.querySelector('easysell-form');
    var btn = form && form.querySelector('button, [role="button"], a');
    if (btn) btn.click();
    else if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function run() { document.querySelectorAll('.product__thumbnails.with-dots').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
